import { Secret, Token } from 'fernet';

/**
 * Encripta un blob de bytes (Uint8Array) usando Fernet.
 * @param data El contenido a cifrar como Uint8Array.
 * @param key La clave Fernet en Base64 (process.env.REACT_APP_FERNET_KEY).
 * @returns Token Fernet cifrado como string.
 */
export function encryptBytes(payload: string, key: string): string {
  const secret = new Secret(key);
  const token = new Token({ secret, time: Math.floor(Date.now() / 1000) });
  return token.encode(payload);
}

/**
 * Descifra un token Fernet y devuelve el payload como string.
 * @param tokenStr El token Fernet cifrado.
 * @param key La clave Fernet en Base64 (process.env.REACT_APP_FERNET_KEY).
 * @returns El contenido descifrado como string.
 */
export function decryptBytes(tokenStr: string, key: string): string {
  const secret = new Secret(key);
  const token = new Token({ secret });
  return token.decode(tokenStr);
} 